import React from 'react'
import { Grid } from '@material-ui/core'

export const SectionHelperText = ({ text }: { text: string }) => {
    return (
        <Grid style={{ marginTop: 26 }}><span>{text}</span></Grid>
    )
}